import { FC } from "react";
import classnames from "classnames";
import { ModalProps } from "antd";
import { IButton } from "../../IButton";
import { CloseSvg } from "../../../assets/customIcons";

import styles from "./ConfirmModal.module.scss";
import BasicModal from "../BasicModal/BasicModal";

interface ConfirmModal extends ModalProps {
  message?: string;
  onClose?: () => void;
  onConfirm: () => void;
}

export const ConfirmModal: FC<ConfirmModal> = ({
  message = "Вы действительно хотите удалить эти данные?",
  onClose,
  onConfirm,
  ...otherProps
}) => {
  const confirmModalDefaultProps = {
    title: "Удаление записи",
    closable: false,
    width: 320,
  };

  return (
    <BasicModal
      {...confirmModalDefaultProps}
      closeIcon={<CloseSvg />}
      onCancel={onClose}
      footer={
        <div className={styles.ConfirmModalButtons}>
          <IButton type="button" onClick={onConfirm}>
            Да
          </IButton>
          <IButton type="button" onClick={onClose} variant="outlined">
            Нет
          </IButton>
        </div>
      }
      {...otherProps}
    >
      {message}
    </BasicModal>
  );
};
